<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="table_wrap">
            <table summary="공지사항" border="1">
              <caption>공지사항</caption>
              <thead>
                <tr>
                  <th scope="col">번호</th>
                  <th scope="col" class="title">제목</th>
                  <th scope="col" class="date">날짜</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="n in order" :key="n.id">
                  <td scope="row" class="num" :class="{import : n.important}"></td>
                  <td v-text="n.title" @click.prevent="goDetail(n.id)" class="issue"></td>
                  <td>{{n.date | moment('YYYY.MM.DD')}}</td>
                </tr>
              </tbody>
              <tbody v-if="getNoticeList.length < 1">
              <tr>
                <td colspan="2">게시글이 없습니다.</td>
              </tr>
              </tbody>
              <tfoot></tfoot>
            </table>
            <div class="moreBtn" v-if="getNoticeList.length >= 1">
              <a @click="foldingList()" class="folding pointer">
                <img src="@/assets/images/back_left.svg">
                접기
              </a>
              <a @click="moreList()" class="more pointer">
                더보기
                <img src="@/assets/images/back_right.svg">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>
<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import EventBus from '@/utils/bus'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '공지사항',
        prevUrl: '/'
      },
      setCount: false,
      sorting: -1,
      enableSort: false,
      noticeList: [],
      importantList: [],
      basicList: []
    }
  },
  computed: {
    ...mapGetters('notice', [
      'getNoticeList',
      'getNoticePage'
    ]),
    ...mapState([
      'checkPopup'
    ]),
    /* 순서 정렬 - TOP여부 > code 가장 최근 게시물이 가장 위에 보이도록 정렬 */
    order () {
      const noticeArray = this.getNoticeList
      // eslint-disable-next-line no-undef
      const data = _.orderBy(noticeArray, ['important', 'code'], ['desc', 'desc'])
      return data
    }
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions('notice', [
      'NOTICE_LIST',
      'NOTICE_DETAIL'
    ]),
    async moreList () {
      /* 더보기 버튼 누를시 : 10개씩 추가 */
      // console.log('getNoticeList.length: ', this.getNoticeList.length)
      let limit = this.getNoticeList.length
      const maxList = limit += 10
      try {
        this.NOTICE_LIST(maxList)
          .then(() => {
            this.carryData()
            this.paging()
          })
      } catch (error) {
        console.log('error :', error);
        console.log('공지사항 리스트에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {

      }
    },
    foldingList () {
      /* 접기 버튼 누를시 : 추가된 리스트 모두 접기 */
      const maxPage = 10
      try {
        this.NOTICE_LIST(maxPage)
          .then(() => {
            this.carryData()
            this.paging()
          })
      } catch (error) {
        console.log('error: ', error)
      } finally {

      }
    },
    paging () {
      const limit = this.getNoticePage
      if (limit === 1) {
        // console.log('getNoticePage: ', this.getNoticePage)
        document.querySelector('.more').classList.add('btnHide')
      } else {
        document.querySelector('.more').classList.remove('btnHide')
      }
    },
    async fetchData () {
      /* 초기 셋팅 : 10개 */
      const maxPage = 10
      try {
        this.NOTICE_LIST(maxPage)
          .then(() => {
            this.carryData()
          })
      } catch (error) {
        this.SET_POPUP(true)
        this.popupSet.content = errorParser.parse(error)
      } finally {
      }
      // this.getNoticeList.sort((a, b) => {
      //   console.log('a: ', a)
      //   console.log('b: ', b)
      // })
    },
    /* 번호 역순으로 매기기 */
    carryData () {
      const noticeArray = this.getNoticeList
      // console.log('noticeArray: ', noticeArray)
      for (let i = noticeArray.length; i >= 0; i--) {
        document.querySelectorAll('.num').forEach((e) => {
          i--
          e.innerText = i + 1
        })
        document.querySelectorAll('.import').forEach((e) => {
          e.innerText = 'TOP'
        })
      }
      if (noticeArray.length <= 10 || noticeArray.length <= 1) {
        console.log('getNoticeList: ', this.getNoticeList)
        document.querySelector('.folding').classList.add('btnHide')
      } else {
        document.querySelector('.folding').classList.remove('btnHide')
      }
      if (noticeArray.length < 10) {
        document.querySelector('.more').classList.add('btnHide')
      } else {
        document.querySelector('.more').classList.remove('btnHide')
      }
    },
    async goDetail (code) {
      console.log('code: ', code)
      // await this.NOTICE_DETAIL(code)
      try {
        await this.$router.push(`/notice/${code}`)
      } catch (error) {
        console.log('error :', error);
        console.log('공지사항 리스트- 상세보기 클릭시 에러발생.')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.fetchData()
  },
  mounted () {
    EventBus.$emit('pageAccess', true)
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
    EventBus.$off('pageAccess')
  }
}
</script>
<style lang="scss" scoped>
</style>
